<section class="connect-page canvas-page">
  @if (error()) {
    <mat-card class="connect-card">
      <mat-card-content class="connect-muted">{{ error() }}</mat-card-content>
    </mat-card>
  }

  <div class="canvas-shell connect-card">
      <header class="canvas-toolbar">
          <div class="canvas-toolbar__meta">
              <div class="workflow-meta">
                  <div class="workflow-meta__name">{{ workflow()?.name || 'Workflow' }}</div>
                  @if ((workflow()?.tags ?? []).length > 0) {
                      <div class="workflow-meta__tags connect-muted">{{ (workflow()?.tags ?? []).join(', ') }}</div>
                  }
              </div>
          </div>

          <div class="canvas-toolbar__actions">
              <div class="primary-actions">
                  <button (click)="toggleWorkflowSettings()" mat-stroked-button type="button">
                      <mat-icon aria-hidden="true">tune</mat-icon>
                      {{ workflowSettingsOpen() ? 'Hide settings' : 'Workflow settings' }}
                  </button>
                  <button color="accent" mat-stroked-button routerLink="/connect/workflows">Back</button>
                  @if (visualizeRunId() && workflow()?.id) {
                      <button (click)="exitRunView()" color="primary" mat-stroked-button type="button">Back to
                          workflow
                      </button>
                  }
                  <button (click)="load(workflow()?.id || '')" [disabled]="loading()" color="primary"
                          mat-stroked-button>Refresh
                  </button>
                  <button (click)="save()" [disabled]="saving() || !workflow()" color="primary" mat-flat-button>Save
                  </button>
              </div>
              <div class="zoom-indicator connect-muted">Nodes {{ nodes().length }} | Edges {{ edges().length }}</div>
          </div>
      </header>

      <div [class.canvas-body--inspector]="selectedNode || selectedEdge || selectedBackground()" class="canvas-body">
          <div class="canvas-main" [class.canvas-main--with-debug]="visualizeRunId()">
            <div class="canvas-stage">
              <div class="canvas-overlay palette-overlay">
                  <app-connect-workflow-node-palette
                          [hasAnyTriggerNodes]="hasAnyTriggerNodes()"></app-connect-workflow-node-palette>
              </div>

              @if (workflowSettingsOpen()) {
                  <div class="canvas-overlay settings-overlay">
                      <div class="overlay-card">
                          <div class="overlay-card__header">
                              <div class="overlay-card__title">Workflow settings</div>
                              <button
                                      (click)="closeWorkflowSettings()"
                                      aria-label="Close workflow settings"
                                      mat-icon-button
                                      type="button"
                              >
                                  <mat-icon>close</mat-icon>
                              </button>
                          </div>

                          <mat-form-field appearance="outline" class="workflow-name">
                <mat-label>Workflow name</mat-label>
                              <input
                                      (input)="updateWorkflowName(($any($event.target).value || ''))"
                                      [value]="workflow()?.name || ''"
                                      matInput
                                      type="text"
                              />
                          </mat-form-field>

                          <mat-form-field appearance="outline" class="workflow-tags">
                <mat-label>Tags</mat-label>
                <mat-chip-grid #tagsChipGrid aria-label="Workflow tags">
                    @for (tag of workflow()?.tags ?? []; track tag) {
                        <mat-chip-row (removed)="removeTag(tag)">
                            {{ tag }}
                            <button [attr.aria-label]="'Remove tag ' + tag" matChipRemove>
                                <mat-icon>cancel</mat-icon>
                            </button>
                        </mat-chip-row>
                    }
                </mat-chip-grid>
                              <input
                                      (matChipInputTokenEnd)="addTag($event)"
                                      [matChipInputAddOnBlur]="true"
                                      [matChipInputFor]="tagsChipGrid"
                                      [matChipInputSeparatorKeyCodes]="tagSeparatorKeysCodes"
                                      placeholder="Add a tag"
                              />
                          </mat-form-field>
                      </div>
                  </div>
              }

              @if (loading()) {
                  <div class="loading-row shell-loading">
                      <mat-progress-spinner diameter="28" mode="indeterminate"></mat-progress-spinner>
                      <span class="connect-muted">Loading workflow...</span>
                  </div>
              } @else {
                <ng-diagram
                  class="diagram-host"
                  [model]="diagramModel"
                  [nodeTemplateMap]="nodeTemplateMap"
                  [config]="diagramConfig"
                  (selectionChanged)="onSelectionChanged($event)"
                  (selectionMoved)="onSelectionMoved($event)"
                  (selectionRemoved)="onSelectionRemoved($event)"
                  (nodeResized)="onNodeResized($event)"
                  (edgeDrawn)="onEdgeDrawn($event)"
                  (paletteItemDropped)="onPaletteItemDropped($event)"
                >
                  <ng-diagram-background type="grid"></ng-diagram-background>
                </ng-diagram>
              }
            </div>

            @if (visualizeRunId()) {
              <app-connect-workflow-debug-panel
                [run]="visualizedRun()"
                [runLoading]="visualizedRunLoading()"
                [runError]="visualizedRunError()"
                [context]="visualizedRunContext()"
                [contextLoading]="visualizedRunContextLoading()"
                [contextError]="visualizedRunContextError()"
                [replay]="visualizedRunReplay()"
                [replayLoading]="visualizedRunReplayLoading()"
                [replayError]="visualizedRunReplayError()"
              ></app-connect-workflow-debug-panel>
            }
          </div>

          @if (selectedNode || selectedEdge || selectedBackground()) {
              <aside class="canvas-sidebar canvas-sidebar--right">
                  <app-connect-workflow-inspector
                          (backgroundDeleted)="onInspectorBackgroundDeleted($event)"
                          (backgroundPatched)="onInspectorBackgroundPatched($event)"
                          (backgroundStylePatched)="onInspectorBackgroundStylePatched($event)"
                          (edgePatched)="onInspectorEdgePatched($event)"
                          (nodePatched)="onInspectorNodePatched($event)"
                          [selectedBackground]="selectedBackground()"
                          [selectedEdge]="selectedEdge"
                          [selectedNode]="selectedNode"
                          [visualizeRunId]="visualizeRunId()"
                          [workflowId]="workflow()?.id || null"
                          class="inspector-panel"
                  ></app-connect-workflow-inspector>
              </aside>
      }
    </div>
  </div>
</section>
